// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import * as i from '../interfaces';

import * as e from '../enums';

export function enumStringToValue<E>(enumRef: any, value: string): E {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}

export class BootstrapperResponse implements i.BootstrapperResponseInterface {
  siteId: string;
  coreCurrentVersion: string;
  coreLatestVersion: string;
  theme: WordPressAddon;
  plugins: WordPressAddon[];

  static fromProto(proto: any): BootstrapperResponse {
    let m = new BootstrapperResponse();
    m = Object.assign(m, proto);
    if (proto.theme) {
      m.theme = WordPressAddon.fromProto(proto.theme);
    }
    if (proto.plugins) {
      m.plugins = proto.plugins.map(WordPressAddon.fromProto);
    }
    return m;
  }

  constructor(kwargs?: i.BootstrapperResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.coreCurrentVersion !== 'undefined') {
      toReturn['coreCurrentVersion'] = this.coreCurrentVersion;
    }
    if (typeof this.coreLatestVersion !== 'undefined') {
      toReturn['coreLatestVersion'] = this.coreLatestVersion;
    }
    if (typeof this.theme !== 'undefined' && this.theme !== null) {
      toReturn['theme'] = 'toApiJson' in this.theme ? (this.theme as any).toApiJson() : this.theme;
    }
    if (typeof this.plugins !== 'undefined' && this.plugins !== null) {
      toReturn['plugins'] = 'toApiJson' in this.plugins ? (this.plugins as any).toApiJson() : this.plugins;
    }
    return toReturn;
  }
}

export class SearchFilters implements i.SearchFiltersInterface {
  partnerId: string;
  pluginUpdating: boolean;
  themeUpdating: boolean;
  coreUpdating: boolean;
  multisite: boolean;

  static fromProto(proto: any): SearchFilters {
    let m = new SearchFilters();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.SearchFiltersInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pluginUpdating !== 'undefined') {
      toReturn['pluginUpdating'] = this.pluginUpdating;
    }
    if (typeof this.themeUpdating !== 'undefined') {
      toReturn['themeUpdating'] = this.themeUpdating;
    }
    if (typeof this.coreUpdating !== 'undefined') {
      toReturn['coreUpdating'] = this.coreUpdating;
    }
    if (typeof this.multisite !== 'undefined') {
      toReturn['multisite'] = this.multisite;
    }
    return toReturn;
  }
}

export class SiteSummary implements i.SiteSummaryInterface {
  partnerId: string;

  static fromProto(proto: any): SiteSummary {
    let m = new SiteSummary();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.SiteSummaryInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}

export class SortOptions implements i.SortOptionsInterface {
  direction: e.SortDirection;
  field: e.SortField;

  static fromProto(proto: any): SortOptions {
    let m = new SortOptions();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue<e.SortDirection>(e.SortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue<e.SortField>(e.SortField, proto.field);
    }
    return m;
  }

  constructor(kwargs?: i.SortOptionsInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}

export class SubSiteInfo implements i.SubSiteInfoInterface {
  blogId: number;
  blogName: string;
  path: string;
  status: string;
  createdAt: string;
  lastUpdated: string;
  metadata: string;

  static fromProto(proto: any): SubSiteInfo {
    let m = new SubSiteInfo();
    m = Object.assign(m, proto);
    if (proto.blogId) {
      m.blogId = parseInt(proto.blogId, 10);
    }
    return m;
  }

  constructor(kwargs?: i.SubSiteInfoInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.blogId !== 'undefined') {
      toReturn['blogId'] = this.blogId;
    }
    if (typeof this.blogName !== 'undefined') {
      toReturn['blogName'] = this.blogName;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.createdAt !== 'undefined') {
      toReturn['createdAt'] = this.createdAt;
    }
    if (typeof this.lastUpdated !== 'undefined') {
      toReturn['lastUpdated'] = this.lastUpdated;
    }
    if (typeof this.metadata !== 'undefined') {
      toReturn['metadata'] = this.metadata;
    }
    return toReturn;
  }
}

export class WordPressAddon implements i.WordPressAddonInterface {
  id: string;
  currentVersion: string;
  latestVersion: string;

  static fromProto(proto: any): WordPressAddon {
    let m = new WordPressAddon();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.WordPressAddonInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.currentVersion !== 'undefined') {
      toReturn['currentVersion'] = this.currentVersion;
    }
    if (typeof this.latestVersion !== 'undefined') {
      toReturn['latestVersion'] = this.latestVersion;
    }
    return toReturn;
  }
}

export class WordPressSite implements i.WordPressSiteInterface {
  siteId: string;
  accountId: string;
  accountGroupName: string;
  primaryDomain: string;
  pluginUpdates: number;
  currentTheme: WordPressAddon;
  currentCoreVersion: string;
  latestCoreVersion: string;
  created: Date;
  updated: Date;
  plugins: WordPressAddon[];
  isMultisite: boolean;
  subsiteInfo: SubSiteInfo[];
  phpVersion?: string;

  static fromProto(proto: any): WordPressSite {
    let m = new WordPressSite();
    m = Object.assign(m, proto);
    if (proto.currentTheme) {
      m.currentTheme = WordPressAddon.fromProto(proto.currentTheme);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.plugins) {
      m.plugins = proto.plugins.map(WordPressAddon.fromProto);
    }
    if (proto.subsiteInfo) {
      m.subsiteInfo = proto.subsiteInfo.map(SubSiteInfo.fromProto);
    }
    return m;
  }

  constructor(kwargs?: i.WordPressSiteInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.siteId !== 'undefined') {
      toReturn['siteId'] = this.siteId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.accountGroupName !== 'undefined') {
      toReturn['accountGroupName'] = this.accountGroupName;
    }
    if (typeof this.primaryDomain !== 'undefined') {
      toReturn['primaryDomain'] = this.primaryDomain;
    }
    if (typeof this.pluginUpdates !== 'undefined') {
      toReturn['pluginUpdates'] = this.pluginUpdates;
    }
    if (typeof this.currentTheme !== 'undefined' && this.currentTheme !== null) {
      toReturn['currentTheme'] =
        'toApiJson' in this.currentTheme ? (this.currentTheme as any).toApiJson() : this.currentTheme;
    }
    if (typeof this.currentCoreVersion !== 'undefined') {
      toReturn['currentCoreVersion'] = this.currentCoreVersion;
    }
    if (typeof this.latestCoreVersion !== 'undefined') {
      toReturn['latestCoreVersion'] = this.latestCoreVersion;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? (this.created as any).toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? (this.updated as any).toApiJson() : this.updated;
    }
    if (typeof this.plugins !== 'undefined' && this.plugins !== null) {
      toReturn['plugins'] = 'toApiJson' in this.plugins ? (this.plugins as any).toApiJson() : this.plugins;
    }
    if (typeof this.isMultisite !== 'undefined') {
      toReturn['isMultisite'] = this.isMultisite;
    }
    if (typeof this.subsiteInfo !== 'undefined' && this.subsiteInfo !== null) {
      toReturn['subsiteInfo'] =
        'toApiJson' in this.subsiteInfo ? (this.subsiteInfo as any).toApiJson() : this.subsiteInfo;
    }
    if (typeof this.phpVersion !== 'undefined') {
      toReturn['phpVersion'] = this.phpVersion;
    }
    return toReturn;
  }
}
